import api from "../utils/api";

const BASE = "/api/admin/brands";

export const getBrands = async (params = {}) =>
  (await api.get(BASE, { params })).data;

export const getBrand = async (id) =>
  (await api.get(`${BASE}/${id}`)).data;

export const createBrand = async (payload) =>
  (await api.post(BASE, payload)).data;

export const createBrandsBulk = async (brands) =>
  (await api.post(`${BASE}/bulk`, { brands })).data;

export const updateBrand = async (id, payload) =>
  (await api.put(`${BASE}/${id}`, payload)).data;

export const deleteBrand = async (id) =>
  (await api.delete(`${BASE}/${id}`)).data;
